import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPleromaComponent } from './simple-icons-pleroma.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPleromaComponent ],
    exports:      [ SimpleIconsPleromaComponent ],
    bootstrap:    []
})
export class SimpleIconsPleromaModule {}
